// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Dz2-J","content":"RecentSearches_content__h5SsG"};